module.exports = __webpack_public_path__ + "1bec4afe3e5bfd73e484893b8ee33d04.svg";